import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import CameraIcon from '@mui/icons-material/PhotoCamera';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import {Link as materialLink} from '@mui/material/Link';
import { Link, useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import { green, red, grey, purple } from '@mui/material/colors';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Avatar } from '@mui/material';



function Copyright() {
  return (
    <Stack
    sx={{ pb: 1 }}
    direction="row"
    spacing={2}
    justifyContent="center"
  >
    {/* <Button variant="contained">Contact</Button> */}
    <Button variant="text" color="custom3" href="https://mail.google.com/mail/?view=cm&fs=1&to=frambatom@gmail.com">Email</Button>
    <Button variant="text" color="custom3" href="https://www.linkedin.com/in/tommaso-framba-a9a7a5199/">LinkedIn</Button>
    <Button variant="text" color="custom3" href="https://github.com/TommasoFramba">Github</Button>
  </Stack>
  );
}


const onDownload = () => {
  const link = document.createElement("a");
  link.download = `TommasoFrambaResume2022.pdf`;
  link.href = "./TommasoFrambaResume2022.pdf";
  link.click();
};


const theme = createTheme({
  palette: {
    text: {
      primary: '#FAFAFA',
      secondary: '#BDBDBD',
    },
    background: {
      default: "#061b2b",
    },
    primary: {
      main: grey[900],
    },
    secondary: {
      main: green[500],
    },
    custom1: {
      light: "#ff6158",
      main: "#e7222e",
      contrastText: "#ffffff",
      dark: "#ac0006",
    },
    custom2: {
      light: "#5284bf",
      main: "#16588e",
      contrastText: "#ffffff",
      dark: "#002f60",
    },
    custom3: {
      light: "#5284bf",
      main: "#4b94cc",
      contrastText: "#ffffff",
      dark: "#002f60",
    }
  },
  neutral: {
    main: '#64748B',
    contrastText: '#fff',
  },
});

export default function App() {
  const navigate = useNavigate();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <main>
        {/* Hero unit */}
        <Box
          sx={{
            pt: 10,
            pb: 6,
          }}
        >
          
          <Container maxWidth="sm">
            <Container
              component="img"
              display='flex'
              alignItems='center'
              justifyContent='center'
              style={{
                minWidth: 100,
                maxWidth: 200,
                borderRadius: 300
              }}
              maxWidth="lg"
              alt="Profile Picture"
              src="https://avatars.githubusercontent.com/u/13773118?s=400&u=75fe8b9fec5063bb6a7e5f3a79d8510f03e17bc6&v=4">

            </Container>
            <Typography
              sx={{
                pt: 2
              }}
              component="h1"
              variant="h4"
              align="center"
              color="text.primary"
              gutterBottom
            >
              Tommaso Framba
            </Typography>
            <Stack
              sx={{ pt: 0 }}
              direction="row"
              spacing={2}
              justifyContent="center"
            >
              {/* <Button variant="contained">Contact</Button> */}
              <Button variant="contained" color="custom2" onClick={() => navigate("/resume") }>Resume</Button>
              <Button variant="contained" color="custom2" onClick={() => navigate("/projects") } >Projects</Button>
              <Button variant="contained" color="custom2" onClick={() => navigate("/about") } >About</Button>
            </Stack>
          </Container>

        </Box>









      </main>
      {/* Footer */}
      <Box sx={{ bgcolor: 'primary', p: 6 }} component="footer">
        <Typography variant="h6" align="center" gutterBottom>
          Contact
        </Typography>
        
        <Copyright />
        <Typography variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      <materialLink color="inherit" href="https://github.com/TommasoFramba">
        Tommaso Framba
      </materialLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
      </Box>
      {/* End footer */}
    </ThemeProvider>
  );


}